import axios from 'axios'
import constants from '../constants'
import { Medication } from "../views/corp/medications/types"
import { RefillData, UpdateDeviceData } from '../views/practice/meds-devices/common/types'
import { Device } from '../views/corp/devices/types'

const getDevices = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer-devices`)
  const devices: Device[] = response?.data

  return devices
}

const getMedications = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer-medications`)
  const medications: Medication[] = response?.data

  return medications
}

const sendRefillRequest = async (customerNumber: string, refillData: RefillData) => {
  await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/kits/sendAutomaticRefillRequest`, refillData)
}

const toggleDeviceActive = async (updateItem: UpdateDeviceData, customerNumber: string) => {
  await axios.put(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/devices/${updateItem.device_id}`, updateItem)
}

export {
  getDevices,
  getMedications,
  sendRefillRequest,
  toggleDeviceActive,
}